import styled from 'styled-components';
import { ThemeTagCard } from '../../../../Tags/ThemeTagCard';

export const Seperator = styled.div`
  font-size: 12px;
  margin-right: 4px;
  margin-left: 4px;
`;

export const Subtitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const NotificationThemeTag = styled(ThemeTagCard)`
  text-transform: uppercase;
  color: ${({ color }) => color};
`;
